// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__AWxKf","empty":"ModalGraph_empty__1nF6i"};